import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Typography} from '@mui/material';
import Layout from '@components/Layout';
import AccountForm from '@components/account/AccountForm';

function AccountPage() {
    const { t } = useTranslation();
    return (
        <Layout>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('My account')}</Typography>
            </Breadcrumbs>
            <AccountForm />
        </Layout>
    );
}

export default AccountPage;
